import React from "react";
import { GoogleAnalyticsContext } from "./google-analytics";
export const useAnalytics = () => {
    const { trackEvent } = React.useContext(GoogleAnalyticsContext);
    return React.useCallback(trackEvent, [trackEvent]);
};
//# sourceMappingURL=hooks.js.map